import { send } from '../../../../../../src/network/network';
import { type CustomerOccasionGoal } from '../../../../../../src/types/CustomerOccasionGoal';

type Params = {
  requestBody: CustomerOccasionGoal;
};

export async function putApiV2CustomersCustomerIdOccasionGoals({
  requestBody,
}: Params) {
  return await send<CustomerOccasionGoal>({
    path: `/api/v2/customers/self/occasion_goals/`,
    method: 'PUT',
    body: requestBody,
  });
}
